import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import XMarkSvg from '@/assets/XMark.svg';

const XMark = ({ size, variant, className }: IconProps) => (
  <img
    src={XMarkSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default XMark;
